import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useViewport } from '@chilecompra/react-kit'
import AppBar from '../../components/Surfaces/AppBar'
import Tab from '../../components/Navigation/Tab'
import Tabs from '../../components/Navigation/Tabs'
import TabPanel from '../../components/Surfaces/TabPanel'
import { sendAnalyticsEvent } from '../../config/settings/analytics'
import { Column } from './BuyerTabWrapper.styles'

/**
 * The Buyer Tab Wrapper's container.
 */
const BuyerTabWrapper = props => {
  const { accessibility, options, prefix } = props
  const {
    size: { isUpToMedium }
  } = useViewport()
  const [value, setValue] = useState(0)

  const { error: buyerError, loading } = useSelector(state => state.basicBuyerInformation)

  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const position = options.findIndex(tab => tab.current)

    if (position === value || position === -1) {
      return
    }

    setValue(position)
  }, [pathname])

  const tabProps = index => {
    return {
      id: `${prefix}-tab-${index}`,
      'aria-controls': `${prefix}-tabpanel-${index}`,
      key: `${prefix}-tab-${index}`,
      value: index
    }
  }

  const tabPanelProps = index => {
    return {
      id: `${prefix}-tabpanel-${index}`,
      ariaLabel: `${prefix}-tab-${index}`
    }
  }

  const handleChange = (_, newValue) => {
    if (newValue === value) {
      return
    }

    navigate(options[newValue].route)
    sendAnalyticsEvent({
      action: `Click tab ${options[newValue].label}`,
      category: 'click-tab-ficha',
      label: options[newValue].label
    })
  }

  return buyerError ? null : (
    <Column margin="0 0 2rem 0" padding={isUpToMedium ? '0 25px 0 0' : '0'}>
      <AppBar position="static" tabsCount={options.length}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label={accessibility.label}
          variant="scrollable"
          scrollButtons="auto"
        >
          {options.map((option, index) => {
            return (
              <Tab
                label={option.label}
                key={`${prefix}-tab-${index}`}
                {...tabProps(index)}
                loading={loading}
                badge={option.badge}
              />
            )
          })}
        </Tabs>
      </AppBar>

      {options.map((option, index) => {
        return (
          <TabPanel value={value} index={index} key={`${prefix}-tabpanel-${index}`} {...tabPanelProps(index)}>
            {option.content}
          </TabPanel>
        )
      })}
    </Column>
  )
}

BuyerTabWrapper.defaultProps = {
  accessibility: {
    label: 'Simple tabs'
  }
}
BuyerTabWrapper.propTypes = {
  accessibility: PropTypes.shape({
    label: PropTypes.string
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node.isRequired,
      current: PropTypes.bool.isRequired,
      label: PropTypes.string.isRequired,
      route: PropTypes.string.isRequired,
      badge: PropTypes.shape({
        label: PropTypes.string.isRequired,
        color: PropTypes.oneOf(['primary'])
      })
    })
  ).isRequired,
  prefix: PropTypes.string.isRequired
}

export default BuyerTabWrapper
